import React from "react";

import { Spinner, SPINNER_SIZES } from "widgets/feedback";

import styles from "./loader.css";

export function Loader() {
  return (
    <div className={styles.loaderBody}>
      <Spinner size={SPINNER_SIZES.LARGE} />
    </div>
  );
}
